<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="B4">
    <v-dialog
      v-model="hasMaxEmployeesDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>Max Employees</v-card-title>
        <v-card-text>
          <div>You've reached the maximum number of employees. Please submit a separate sheet with the information requested.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="hasMaxEmployeesDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">General Health Benefit Information 1</div>
          </v-col>

            <!-- Cobra -->
            <v-col
              cols="12"
              class="mt-5 pb-0"
            >
              <div class="text-md-body-1 text-body-2">Are there any employees currently on COBRA or eligible?</div>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-radio-group
                v-model="employeesOnCobra"
                row
                class="mt-0"
              >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <!-- Cobra Card / Row Details -->
            <v-col cols="12" class="mt-5" v-show="employeesOnCobra === true">
              <v-card
                flat
                outlined
                rounded="lg"
                v-for="(item, index) in employeesCurrentlyOnCobra"
                :key="index"
                class="mb-5"
              >
                <v-row class="mx-5">
                  <v-col cols="12" class="d-flex-column">
                    <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Cobra Employee #{{ index + 1 }}</div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="item.name"
                      outlined
                      label="Name"
                      class="rounded-lg"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="cobraBirthdayMenu"
                      v-model="item.birthdayMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dob"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.dob"
                          outlined
                          label="Birth Date"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dob"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.birthdayMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.cobraBirthdayMenu[index].save(item.dob)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="cobraEffectiveDateMenu"
                      v-model="item.cobraDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.effectiveDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.effectiveDate"
                          outlined
                          label="Effective Date"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.effectiveDate"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.cobraDateMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.cobraEffectiveDateMenu[index].save(item.effectiveDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="item.event"
                      outlined
                      label="Activating Event"
                      class="rounded-lg"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="cobraDateOfEventMenu"
                      v-model="item.dateOfEventMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dateOfEvent"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.dateOfEvent"
                          outlined
                          label="Date Of Event"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dateOfEvent"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.dateOfEventMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.cobraDateOfEventMenu[index].save(item.dateOfEvent)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    large
                    @click="removeCobraEmployee(index)"
                  >
                    <v-icon left>mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" v-show="employeesOnCobra === true">
              <v-btn
                color="secondary"
                outlined
                @click="addCobraEmployee"
              >
                Add Cobra Employee
              </v-btn>
            </v-col>

            <!-- Election -->
            <v-col
              cols="12"
              class="mt-5 pb-0"
            >
              <div class="text-md-body-1 text-body-2">Are there any employees still within their COBRA election period or may become eligible as of the proposed medical coverage effective date?</div>
            </v-col>
            <v-col cols="12">
              <div class="text-subtitle-2 blue-text text--darken-4">If yes, please provide additional details.</div>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-radio-group
                v-model="employeesinCobraElectionPeriod"
                row
                class="mt-0"
              >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <!-- Election Card / Row Details -->
            <v-col cols="12" class="mt-5" v-show="employeesinCobraElectionPeriod === true">
              <v-card
                flat
                outlined
                rounded="lg"
                v-for="(item, index) in cobraElectionPeriod"
                :key="index"
                class="mb-5"
              >
                <v-row class="mx-5">
                  <v-col cols="12" class="d-flex-column">
                    <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Election Employee #{{ index + 1 }}</div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="item.name"
                      outlined
                      label="Name"
                      class="rounded-lg"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="electionBirthdayMenu"
                      v-model="item.birthdayMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dob"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.dob"
                          outlined
                          label="Birth Date"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dob"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.birthdayMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.electionBirthdayMenu[index].save(item.dob)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="electionEffectiveDateMenu"
                      v-model="item.effectiveDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.effectiveDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.effectiveDate"
                          outlined
                          label="Date of Termination"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.effectiveDate"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.effectiveDateMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.electionEffectiveDateMenu[index].save(item.effectiveDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="item.event"
                      outlined
                      label="Activating Event"
                      class="rounded-lg"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="electionDateOfEventMenu"
                      v-model="item.dateOfEventMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dateOfEvent"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.dateOfEvent"
                          outlined
                          label="Date Of Event"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dateOfEvent"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.dateOfEventMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.electionDateOfEventMenu[index].save(item.dateOfEvent)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    large
                    @click="removeElectionEmployee(index)"
                  >
                    <v-icon left>mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="12" v-show="employeesinCobraElectionPeriod === true">
              <v-btn
                color="secondary"
                outlined
                @click="addElectionEmployee"
              >
                Add Election Employee
              </v-btn>
            </v-col>

            <!-- Pregnant -->
            <v-col
              cols="12"
              class="mt-5 pb-0"
            >
              <div class="text-md-body-1 text-body-2">Is anyone currently pregnant? This includes employees, dependents, or COBRA participants.</div>
            </v-col>
            <v-col cols="12">
              <div class="text-subtitle-2 blue-text text--darken-4">If yes, please provide additional details by pressing Add Pregnant Employee below.</div>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-radio-group
                v-model="currentPregnancies"
                row
                class="mt-0"
              >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <!-- Pregnant Card / Row Details -->
            <v-col cols="12" class="mt-5" v-show="currentPregnancies === true">
              <v-card
                flat
                outlined
                rounded="lg"
                v-for="(item, index) in employeesCurrentlyPregnant"
                :key="index"
                class="mb-5"
              >
                <v-row class="mx-5">
                  <v-col cols="12" class="d-flex-column">
                    <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Pregnant Employee #{{ index + 1 }}</div>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="pregnancyDueDateMenu"
                      v-model="item.dueDateMenu"
                      :close-on-content-click="false"
                      :return-value.sync="item.dueDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.dueDate"
                          outlined
                          label="Due Date"
                          class="rounded-lg"
                          hide-details
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.dueDate"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="item.dueDateMenu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.pregnancyDueDateMenu[index].save(item.dueDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="item.condition"
                      outlined
                      label="Type of Pregnancy or Condition"
                      class="rounded-lg"
                      hide-details
                      placeholder="normal, high risk, preterm labor"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    large
                    @click="removePregnantEmployee(index)"
                  >
                    <v-icon left>mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="12" v-show="currentPregnancies === true">
              <v-btn
                color="secondary"
                outlined
                @click="addPregnantEmployee"
              >
                Add Pregnant Employee
              </v-btn>
            </v-col>

            <BenefitsBtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BenefitsBtnContinue from './btnBenefitsContinue.vue';

export default {
  name: 'BenefitsStepFour',
  components: {
    BenefitsBtnContinue,
  },
  data: () => ({
    effectiveDateMenu: false,
    hasMaxEmployeesDialog: false,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    generalInfo: {
      get() {
        return this.$store.state.benefitsPacket.generalInfo;
      },
      set(value) {
        this.$store.commit('updateGeneralInfo', value);
      },
    },
    currentPregnancies: {
      get() {
        return this.$store.state.benefitsPacket.flags.currentPregnancies;
      },
      set(value) {
        this.$store.commit('updateCurrentPregnancies', value);
      },
    },
    employeesCurrentlyPregnant: {
      get() {
        return this.$store.state.benefitsPacket.pregnancies;
      },
      set(value) {
        this.$store.commit('updateBenefitsPregnancies', value);
      },
    },
    employeesOnCobra: {
      get() {
        return this.$store.state.benefitsPacket.flags.employeesOnCobra;
      },
      set(value) {
        this.$store.commit('updateEmployeesOnCobra', value);
      },
    },
    employeesCurrentlyOnCobra: {
      get() {
        return this.$store.state.benefitsPacket.cobraCurrentPeriod;
      },
      set(value) {
        this.$store.commit('updateCobraEmployees', value);
      },
    },
    employeesinCobraElectionPeriod: {
      get() {
        return this.$store.state.benefitsPacket.flags.employeesinCobraElectionPeriod;
      },
      set(value) {
        this.$store.commit('updateEmployeesinCobraElectionPeriod', value);
      },
    },
    cobraElectionPeriod: {
      get() {
        return this.$store.state.benefitsPacket.cobraElectionPeriod;
      },
      set(value) {
        this.$store.commit('updateCobraElectionPeriod', value);
      },
    },
  },
  methods: {
    download() {
      this.downloadClicked = true;
    },
    addCobraEmployee() {
      const employee = {
        name: null,
        dob: null,
        event: null,
        activatingEvent: null,
        effectiveDate: null,
        dateOfEvent: null,
        dobMenu: false,
        effectiveDateMenu: false,
        dateOfEventMenu: false,
      };

      // Max number of 4
      if (this.employeesCurrentlyOnCobra.length <= 3) {
        this.employeesCurrentlyOnCobra.push(employee);
      } else {
        this.hasMaxEmployeesDialog = true;
      }
    },
    addElectionEmployee() {
      const employee = {
        name: null,
        dob: null,
        event: null,
        activatingEvent: null,
        effectiveDate: null,
        dateOfEvent: null,
        dobMenu: false,
        effectiveDateMenu: false,
        dateOfEventMenu: false,
      };

      // Max number of 4
      if (this.cobraElectionPeriod.length <= 3) {
        this.cobraElectionPeriod.push(employee);
      } else {
        this.hasMaxEmployeesDialog = true;
      }
    },
    addPregnantEmployee() {
      const pregnantEmployee = {
        dueDate: null,
        condition: null,
      };
      // Max number of 3
      if (this.employeesCurrentlyPregnant.length <= 2) {
        this.employeesCurrentlyPregnant.push(pregnantEmployee);
      } else {
        this.hasMaxEmployeesDialog = true;
      }
    },
    removeElectionEmployee(value) {
      this.cobraElectionPeriod.splice(value, 1);
    },
    removeCobraEmployee(value) {
      this.employeesCurrentlyOnCobra.splice(value, 1);
    },
    removePregnantEmployee(value) {
      this.employeesCurrentlyPregnant.splice(value, 1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
